export { default as Avatar } from './Avatar.vue';
export { default as MainLayout } from './layout/MainLayout.vue';
export { default as MotivationalMessage } from './MotivationalMessage.vue';
export { default as NavBar } from './NavBar.vue';
export { default as ChildAvatar } from './child/ChildAvatar.vue';
export { default as ChildHomeData } from './child/ChildHomeData.vue';
export { default as ChildMain } from './child/ChildMain.vue';
export { default as ParentChildHomeData } from './parent/ParentChildHomeData.vue';
export { default as ParentMain } from './parent/ParentMain.vue';
export { default as ConfirmModal } from './modal/ConfirmModal.vue';
export { default as InputFile } from './inputFile/InputFile.vue';
export { default as LoadingOverlay } from './loaders/LoadingOverlay';
export { default as TagsList } from './tags/TagsList';
export { default as UpdateUserForm } from './forms/UpdateUserForm.vue';
export { default as SettingsSkeleton } from './skeletons/SettingsSkeleton.vue';

